import React, { Component } from "react";
import Store from "../../content/Store";
import Content from "../../content/Content";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import styles from "../../assets/css/modules/myprofile/myprofilecontactprefs.css";
import HelpSection from "../shared/HelpSection";
import PromoImageCard from "../../components/shared/PromoImageCard";
import MskSection from "../shared/MskSection";
import { PersonConsent } from "../shared/PersonConsent";
import SwitchSlider from "../shared/SwitchSlider";
import PrintPreferenceRequired from "../shared/PrintPreferenceRequired";
import PreferenceRequired from '../shared/PreferenceRequired';
import MemberHelper from "../../helpers/MemberHelper";
import DateHelper from "../../helpers/DateHelper";
import ContactPreferenceSection from "../shared/ContactPreferenceSection";
import {
  updatePrintPreferences,
  updateContactPreferences,
  saveContactPreferences,
  loadOptionValues,
  setIsValueChanged,
} from "../../actions/policy/policyActions";
import { PolicyType } from "../../constants/Constants";
import TabNavWithHeader from "../../components/shared/navigation/TabNavWithHeader";
import { Paths } from "../../constants/UrlConstants";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import InternalViewButton from "../shared/buttons/InternalViewButton";
import ContactPreferenceButton from "../shared/buttons/ContactPreferenceButton";
import { sendDataLayerEvent } from "../../analytics/google/GoogleTagManagerDataLayerEvents";
import { GoogleTagManagerConstants } from "../../analytics/google/GoogleTagManagerConstants";

const getPrintPreferenceCopy = (printPreferencePolicyType) => {
  if (printPreferencePolicyType === PolicyType.SME) {
    return Store.MyProfileContactPreferences.PrintPreferenceCopyForSME;
  }
  return Store.MyProfileContactPreferences.PrintPreferenceCopyForIndividual;
};

const getPrintPreferencePolicyType = (selectedPolicy) => {
  let smePolicyType = false;

  if (selectedPolicy && selectedPolicy.IsFormat2) {
    if (!(selectedPolicy.IsHealthSelect && selectedPolicy.IsIndividual)) {
      smePolicyType = true;
    }
  } else {
    if (selectedPolicy && selectedPolicy.IsSME) {
      smePolicyType = true;
    }
  }

  if (smePolicyType) {
    return PolicyType.SME;
  }

  return PolicyType.Individual;
};

export const mapStateToProps = ({ policyReducer = {}, preferenceReducer = {} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );
  const policyType = getPrintPreferencePolicyType(selectedPolicy);
  const isAgeAbove18 = DateHelper.isAgeAbove18(currentMember.DateOfBirth);
  return {
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    Members: selectedPolicy && selectedPolicy.Members,
    IsInternational: selectedPolicy && selectedPolicy.IsInternational,
    IsSaga: selectedPolicy && selectedPolicy.IsSaga,
    IsHealthSelect: selectedPolicy && selectedPolicy.IsHealthSelect,
    DocumentPreference: currentMember.DocumentPreference,
    PrintPreferenceContent: getPrintPreferenceCopy(policyType),
    PolicyType: policyType,
    IsLapsed: selectedPolicy && selectedPolicy.IsLapsed,
    PersonConsent: selectedPolicy && selectedPolicy.PersonConsent,
    TelephonePolicyServicing:
      selectedPolicy &&
      selectedPolicy.PolicyServicingTelephones &&
      selectedPolicy.PolicyServicingTelephones.TelephonePolicyServicing,
    disabled:
      policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView,
    contactPreferencekeys: preferenceReducer.contactPreferencekeys,
    contactValue : preferenceReducer.contactValue,
    saveContactPref: preferenceReducer.saveContactPref,
    isElgibleCustomised: preferenceReducer.isElgibleCustomised,
    personnotfound: preferenceReducer.personnotfound,
    isAgeAbove18
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updatePrintPreferences: (membershipNumber, documentPreference) =>
      dispatch(updatePrintPreferences(membershipNumber, documentPreference)),
    saveContactPreferences:(membershipNumber,updateContactPreferences)=>
      dispatch(saveContactPreferences(membershipNumber,updateContactPreferences)),
    loadOptionValues: (MembershipNumber) => dispatch(loadOptionValues(MembershipNumber)),
    setIsValueChanged:(Value) => dispatch(setIsValueChanged(Value)),
    updateContactPreferences: (
      membershipNumber,
      personConsent,
      history,
      redirectionNotRequired
    ) =>
      dispatch(
        updateContactPreferences(
          membershipNumber,
          personConsent,
          history,
          redirectionNotRequired
        )
      )
  };
};

export class MyProfileContactPreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PersonConsent: props.PersonConsent,
      shownErrors: null,
      shownContactErrors:false,
      preferenceErrors: false,
      preferenceUpdateSuccess: false,
      contactPreferenceUpdateSucceeded: false,
      contactPrefsUpdateSucceeded:false,
      updateContactPreferences:null,
      localDocumentPreference: props.DocumentPreference,
      MemberName:null,
      noSelectionError:false,
      IsOnChange:false,
      noChangesError:false,
    };
    this.changePrintPreference = this.changePrintPreference.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onContactPreferenceSubmit = this.onContactPreferenceSubmit.bind(this);
  }

  componentDidMount(){
    if(this.props.Members !== null && this.props.Members !== undefined){
      let loggedInMember=this.props.Members.find((val)=>val.IsLoggedInMember===true);
      if(loggedInMember !== null && loggedInMember !== undefined)
      {
        this.setState({ MemberName:loggedInMember.FullName});
      }
    }
  }

onContactPreferenceSubmit(e) {
  e.preventDefault();

  this.props.setIsValueChanged(false);
  if(this.state.updateContactPreferences !== null && 
    this.state.updateContactPreferences.length !== 0)
  {
      this.setState({
        shownContactErrors: false,
        noSelectionError:false,
        contactPrefsUpdateSucceeded: false,
        IsOnChange:false,
        noChangesError:false,
      });

      this.props
        .saveContactPreferences(
          this.props.MembershipNumber,
          this.state.updateContactPreferences,
        )
        .then(() => {
        if(this.props.saveContactPref !==null && 
          this.props.saveContactPref !== undefined && 
          this.props.saveContactPref !== false)
        {
          this.props.loadOptionValues(this.props.MembershipNumber);
          this.setState({
            shownContactErrors: false,
            noSelectionError:false,
            contactPrefsUpdateSucceeded: true,
            IsOnChange:false,
            noChangesError:false,
          });
        }
        else{
          this.setState({
            shownContactErrors: true,
            noSelectionError:false,
            contactPrefsUpdateSucceeded: false,
            IsOnChange:false,
            noChangesError:false,
          });
        }
      });
  }
}

onSubmit(e) {
    e.preventDefault();

    this.setState({
      shownErrors: null,
      contactPreferenceUpdateSucceeded: false
    });

    this.props
      .updateContactPreferences(
        this.props.MembershipNumber,
        this.state.PersonConsent,
        this.props.history,
        true
      )
      .then(() => {
        this.setState({
          shownErrors: null,
          contactPreferenceUpdateSucceeded: true
        });
      })
      .catch(() =>
        this.setState({
          shownErrors: Store.GDPR.ValidationErrors.ServerError,
          contactPreferenceUpdateSucceeded: false
        })
      );
  }

  changePrintPreference(event) {
    let documentPreference = event.target.checked;
    this.setState({
      preferenceUpdateSuccess: false,
      preferenceErrors: false,
      localDocumentPreference: documentPreference
    });
    sendDataLayerEvent({
      event:
        GoogleTagManagerConstants.eventTypes
          .receiveDocumentsPreferenceChangeEvent,
      eventAction: `${documentPreference ? "yes" : "no"}`
    });
    this.props
      .updatePrintPreferences(this.props.MembershipNumber, documentPreference)
      .then(() => {
        this.setState({
          preferenceUpdateSuccess: true
        });
      })
      .catch(() =>
        this.setState({
          preferenceErrors: true,
          localDocumentPreference: !documentPreference
        })
      );
  }

  render() {
    return this.props.IsLapsed && !this.props.PersonConsent ? (
      <Redirect to={Paths.NotFound} />
    ) : (
      <div className={styles.myProfileContactPreferences}>
        <TabNavWithHeader
          heading={Store.MyProfileHeader.Heading}
          backgroundColourClass={styles.backgroundColourClass}
          links={
            this.props.IsInternational || this.props.IsSaga
              ? Store.MyProfileHeader.LinksWithoutPermissions
              : Store.MyProfileHeader.Links
          }
          currentLinkIndex={1}
        />
        <TabNavWithHeader
          applyTabNavWithImageStyles={true}
          links={ this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true
                  ?Store.CustomisedPreference.Links
                  : Store.CustomisedPreference.LinksWithoutCommunicationNeed}
          currentLinkIndex={0}
        />
        <ShadowedContainer>
          <div className={styles.pageContainer}>
            {this.props.IsLapsed ? null : (
              <div className="row">
                <div
                  id="printPreferenceSection"
                  className={"col-12 " + styles.printPreferenceSection}
                >
                  <h2>
                    {this.props.PolicyType === PolicyType.Individual ? (
                      <Content
                        name={
                          Store.MyProfileContactPreferences.HeadingForIndividual
                        }
                      />
                    ) : (
                      <Content
                        name={Store.MyProfileContactPreferences.HeadingForSME}
                      />
                    )}
                  </h2>
                  <Content
                    name={this.props.PrintPreferenceContent}
                    params={{
                      telephoneNumber: this.props.TelephonePolicyServicing
                    }}
                  />
                  <PrintPreferenceRequired isPrintPreferenceRequired>
                    <div id="printPreferences">
                      <div className={styles.printPrefInputRow}>
                        <div className="row justify-content-between align-items-center">
                          <div className="col col-md-9 col-lg-10">
                            <label
                              htmlFor="printPreferences"
                              className="m-0 align-middle"
                            >
                              <Content
                                name={Store.MyProfileContactPreferences.Label}
                              />
                            </label>
                          </div>
                          <div className="col text-right">
                            <div className="d-inline-block align-middle">
                              <SwitchSlider
                                id="printPreferencesInput"
                                currentValue={
                                  typeof this.state.localDocumentPreference ===
                                  "undefined"
                                    ? this.props.DocumentPreference
                                    : this.state.localDocumentPreference
                                }
                                onChange={this.changePrintPreference}
                                disabled={this.props.disabled}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.preferenceErrors ? (
                        <div
                          className={
                            "alert alert-danger mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content
                            name={
                              Store.MyProfileContactPreferences.Errors
                                .PreferenceUpdateFailed
                            }
                          />
                        </div>
                      ) : null}
                      {this.state.preferenceUpdateSuccess ? (
                        <div
                          className={
                            "alert alert-success mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content
                            name={
                              Store.MyProfileContactPreferences
                                .PreferenceUpdateSucceeded
                            }
                          />
                        </div>
                      ) : null}
                    </div>
                  </PrintPreferenceRequired>
                </div>
              </div>
            )}
            <PreferenceRequired isPreferenceRequired 
            keys={this.props.contactPreferencekeys}
            values={this.props.contactValue}>
            {this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true &&
            (<div>
            <hr className={styles.horizontalLine} />
            {(this.props.contactPreferencekeys !== null && this.props.contactValue !== undefined?(<div className="row">
              <div id="contactPreferenceSection" className="col-12">
                <h2><Content
                      name={Store.MyProfileContactPreferences.ContactSection.Heading}
                    /></h2>
                <Content
                      name={Store.MyProfileContactPreferences.ContactSection.Subheading}
                    />
                <ContactPreferenceSection 
                    contactPrefsKeys={this.props.contactPreferencekeys}
                    contactValue={this.props.contactValue}
                    MemberName={this.state.MemberName}
                    SaveContactPref={this.props.saveContactPref}
                    IsContactValueChanged={(value)=>
                    this.setState({
                      IsOnChange:value
                    })}
                    updateContactPreferences={(contactprefs) =>
                      this.setState({
                        updateContactPreferences: contactprefs,
                        shownContactErrors: null,
                        contactPrefsUpdateSucceeded: false,
                        noSelectionError:false
                      })
                    }
                    Zebrafied={true}
                    UseSlider={false}></ContactPreferenceSection>
                    <div id="personconsentMessage">
                      {this.state.shownContactErrors ? (
                        <div
                          className={
                            "alert alert-danger mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content name={Store.MyProfileContactPreferences.SaveContactPreferenceError} />
                        </div>
                      ) : null}
                      {this.state.noSelectionError ? (
                        <div
                          className={
                            "alert alert-danger mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content name={Store.MyProfileContactPreferences.noSelectionContactPreferenceError} />
                        </div>
                      ) : null}
                      {this.state.contactPrefsUpdateSucceeded ? (
                        <div
                          className={
                            "alert alert-success mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content
                            name={
                              Store.MyProfileContactPreferences
                                .SaveContactPreferenceSuccess
                            }
                          />
                        </div>
                      ) : null}
                      {this.state.noChangesError ?(
                          <div
                          className={
                            "alert alert-danger mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content
                            name={
                              Store.MyProfileContactPreferences
                                .NoChangesMessage
                            }
                          />
                        </div>
                      ):null}
                    </div>
                <form onSubmit={this.onContactPreferenceSubmit}>
                    <div className={"row " + styles.contactSection}>
                      <div className="col-sm-12 text-right">
                        <ContactPreferenceButton
                          id="btn-contactPreference"
                          type="submit"
                          className="form-control btn btn-submit"
                          disabled={this.props.disabled}
                          label={
                            Store.MyProfileContactPreferences.UpdateButton
                          }
                        />
                      </div>
                    </div>
                  </form>
              </div>
            </div>):
            (<div
              className={
                "alert alert-danger mt-2 " + styles.messages
              }
              role="alert"
            >
              <Content
                name={
                  Store.MyProfileContactPreferences.Errors.GetMasterDataFailed
                }
              />
            </div>))}
          </div>)}
          </PreferenceRequired>
          <hr className={styles.horizontalLine} />
            {this.state.PersonConsent ? (
              <div className="row">
                <div id="contactPreferenceSection" className="col-12">
                  <div className="login">
                    <h2>{Store.MyProfileContactPreferences.MarketingSection}</h2>
                    <Content
                      name={Store.MyProfileContactPreferences.GDPRDescription}
                    />
                    <div className={styles.gdprSection}>
                      <PersonConsent
                        PersonConsent={this.state.PersonConsent}
                        updateConsent={(consent) =>
                          this.setState({
                            PersonConsent: consent,
                            shownErrors: null,
                            contactPreferenceUpdateSucceeded: false
                          })
                        }
                        Zebrafied={true}
                        UseSlider={false}
                      />
                    </div>
                    <Content name={Store.GDPR.Notice} />
                    <div id="personconsentMessage">
                      {this.state.shownErrors ? (
                        <div
                          className={
                            "alert alert-danger mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content name={this.state.shownErrors} />
                        </div>
                      ) : null}
                      {this.state.contactPreferenceUpdateSucceeded ? (
                        <div
                          className={
                            "alert alert-success mt-2 " + styles.messages
                          }
                          role="alert"
                        >
                          <Content
                            name={
                              Store.MyProfileContactPreferences
                                .ContactPreferencesUpdateSucceeded
                            }
                          />
                        </div>
                      ) : null}
                    </div>
                    <form onSubmit={this.onSubmit}>
                      <div className={"row " + styles.gdprSection}>
                        <div className="col-sm-12 text-right">
                          <InternalViewButton
                            id="btn-contactPreference"
                            type="submit"
                            className="form-control btn btn-submit"
                            disabled={this.props.disabled}
                            label={
                              Store.MyProfileContactPreferences.UpdateButton
                            }
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="row">
              <div className="col-12">
                <div className={styles.helpSection}>
                  <HelpSection
                    HeadingLinkText={
                      Store.MyProfileContactPreferences.HelpSection
                        .HeadingLinkText
                    }
                    HeadingLinkTo={
                      Store.MyProfileContactPreferences.HelpSection
                        .HeadingLinkTo
                    }
                    MoreHelpLinkText={
                      Store.MyProfileContactPreferences.HelpSection
                        .MoreHelpLinkText
                    }
                    MoreHelpLinkTo={
                      Store.MyProfileContactPreferences.HelpSection
                        .MoreHelpLinkTo
                    }
                    HelpSet={Store.MyProfileContactPreferences.HelpSection.Faq}
                  />
                </div>
              </div>
            </div>
          </div>
        </ShadowedContainer>
        <div className={"home " + styles.healthStore}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                {!this.props.IsLapsed && (this.props.isAgeAbove18 ?<MskSection UniqueKey="mskBanner" accessPage={Paths.MyProfileContactPreferences}  />:
                (<PromoImageCard
                ImgSrc={Store.Home.Cards.AskMedExpert.IconSrc}
                ImgSrcMobile={Store.Home.Cards.AskMedExpert.IconSrcMobile}
                Heading={Store.Home.Cards.AskMedExpert.Heading}
                Description={Store.Home.Cards.AskMedExpert.Description}
                LinkText={Store.Home.Cards.AskMedExpert.LinkText}
                LinkTo={Store.Home.Cards.AskMedExpert.LinkTo}
                LeftImage
              />))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyProfileContactPreferences);
